module.exports = __webpack_public_path__ + "static/media/nat-3-large.417d3d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nat-3-large.jpg
// module id = 847
// module chunks = 0